module.exports = __webpack_public_path__ + "img/electrFalse.cea37a5c.png";